/* import __COLOCATED_TEMPLATE__ from './sh-payment-line-items-list.hbs'; */
import { readOnly } from '@ember/object/computed';
import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { SH_PAYMENT } from "../../../../models/sh-payment";

/**
 * This is the admin view for an sh-payments's line items list view
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'div',
  classNames: ['SH-c-sh-payment-line-items-list'],

  /**
   * Register services
   */
  constants: service(),
  state: service('states/routes/admin/accounting/payout/sh-payment'),
  stateManager: service('state-managers/routes/admin/accounting/payout/sh-payment'),

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @param {ShPayment}
   */
  shPayment: null,

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  /*********************************
   * PRIVATE
   **********************************/

  /**
   * @type {Boolean}    True if we are allowed to release this payment.
   */
  _isCanReleasePayment: computed(
    'shPayment.{isFinal,statusText}',
    function() {
      return this.get('shPayment.isFinal')
        && this.get('shPayment.statusText') !== SH_PAYMENT.STATUS.PAID;
    }
  ),

  _releasePaymentButtonDisabled: computed(
    '_isCanReleasePayment',
    'state.isLoadingPayment',
    function() {
      return this.state.isLoadingPayment || !this._isCanReleasePayment;
    }
  ),

  /**
   * @type {Number}     Total amount of the payment.
   */
  _totalAmount: readOnly('shPayment.totalAmount'),

  actions: {
    /**
     *
     */
    onAddNewLineItemClicked: function() {
      let modalModel = {
        shPayment: this.get('shPayment'),
        onAddLineItemAdded: () => {
          this.get('stateManager').lineItemAdded();
        }
      };

      showModal(this, 'admin/edit-sh-billable-line-item-modal', modalModel);
    },

    /**
     *
     */
    onReleasePaymentClicked() {
      this.get('stateManager').releasePayment();
    }
  }
});
